import styled from 'styled-components';

import { Box, Image as WikrImage } from 'components/library';

import { color } from 'theme/selectors';

export const Container = styled(Box)`
  border-bottom: 1px solid ${color('border-default')};
`;

export const FlexWrapper = styled(Box)`
  display: flex;
  align-items: center;
  max-width: 400px;
  margin: 0 auto;
`;

export const ContentWrapper = styled(FlexWrapper)`
  > * {
    width: 100%;
  }
`;

export const AvatarWrapper = styled(FlexWrapper)<{ $paddingTop?: number; $paddingBottom?: number; $paddingX?: number }>`
  gap: 24px;

  ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
  ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
  ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
`;

export const Image = styled(WikrImage)`
  width: 48px;
`;
